var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isDetailView)?_c('v-container',[_c('sr-breadcrumbs',{attrs:{"items":[
        { text: 'Home', to: { name: 'Home' } },
        { text: 'Rubrics', to: { name: 'AllRubrics' }, disabled: true },
      ]}}),_c('v-row',[_c('v-col')],1),_c('v-row',[_c('v-col',[_c('rubric-widget')],1)],1)],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }